const Style = {
    container: 'w-full h-full flex-col',
    main: 'flex flex-col p-5',
    header: 'flex justify-between items-center p-4 mt-5 border-b border-gray-200',
    emails: 'flex flex-col w-80',
    subTitle: 'text-xl font-semibold pb-2',
};

export default Style;